import _ from "lodash";
import {formatDate} from "element-ui/src/utils/date-util";

import AthubCloudApi from "@/api/athubCloud";
import PersonServer from "@/api/person";
import DutyServer from "@/api/duty";

import {getDepartmentsByIds} from "@/service/department-service";

export function resetMemberIsLeader(member, position) {
    if (member != null && position != null && (String(position.id) === '34' || position.name === 'M1值班主管' || position.code === 'LEADER')) {
        member.isLeader = true;
    }
}

export function getPersonByEmployeeCode(employeeCode, personsMap) {
    return employeeCode == null ? null : personsMap[employeeCode];
}

export function getPositionById(id, positionsMap) {
    return id == null ? null : positionsMap[id];
}

export async function getPositions(positionIds) {
    let positions = [];

    if (positionIds != null && positionIds.length > 0) {
        let allPositions = await AthubCloudApi.fetchDeptpostList();
        for (let i = 0, len = allPositions.length; i < len; i++) {
            if (positionIds.indexOf(allPositions[i].id)) {
                positions.push(allPositions[i]);
            }
        }
    }
    return Promise.resolve(positions);
}
export async function getPersons(employeeCodes) {
    let persons = [];
    if (employeeCodes != null && employeeCodes.length > 0) {
        let response = await PersonServer.personApi.list({personids: employeeCodes});
        if (response.data.code === 200) {
            persons = response.data.data;
        }
    }
    return Promise.resolve(persons);
}

export async function parseSchedulesForDepartment(schedules) {
    let departmentIds = schedules.filter(e => e != null).map(item => item.departmentId).filter(e => e != null);
    let departments = await getDepartmentsByIds(departmentIds);
    let departmentsMap = _.keyBy(departments, 'deptid');
    schedules.forEach(e => {
        if (e != null && e.departmentId != null) {
            let department = departmentsMap[e.departmentId];
            if (department != null) {
                e.departmentName = department.deptname;
            }
        }
    });
    return Promise.resolve(schedules);
}

export async function parseSchedulesFromEmployee(schedules) {
    let employeeCodeSet = new Set();
    let hasLeader = false;
    schedules.forEach(schedule => {
        if (schedule != null && schedule.members != null && schedule.members.length > 0) {
            schedule.members.forEach(member => {
                if (member.isLeader === true) {
                    hasLeader = true;
                }
                if (member.employeeCode != null) {
                    employeeCodeSet.add(member.employeeCode);
                }
            });
        }
    });
    let employeeCodes = Array.from(employeeCodeSet);
    let persons = await getPersons(employeeCodes);
    let positions = [];
    if (hasLeader === false) {
        let positionIds = Array.from(new Set(persons.map(e => e.title).filter(e => e != null)));
        positions = await getPositions(positionIds);
    }
    let personsMap = _.keyBy(persons, 'personid');
    let positionsMap = _.keyBy(positions, 'id');
    schedules.forEach(schedule => {
        if (schedule != null && schedule.members != null && schedule.members.length > 0) {
            schedule.members.forEach(member => {
                let person = getPersonByEmployeeCode(member.employeeCode, personsMap);
                if (member.employeeName == null && person != null) {
                    member.employeeName = person.realname;
                }
                if (hasLeader === false && person != null) {
                    resetMemberIsLeader(member, getPositionById(person.title, positionsMap));
                }
            });
            schedule.members.sort((a, b) => a.isLeader && !b.isLeader ? -1 : a.isLeader && b.isLeader || !a.isLeader && !b.isLeader ? 0 : 1);
        }
    });
    return Promise.resolve(schedules);
}

export async function parseSchedules(schedules) {
    schedules = await parseSchedulesForDepartment(schedules);
    schedules = await parseSchedulesFromEmployee(schedules);
    return Promise.resolve(schedules);
}

export async function getWorkScheduleLogbook(departmentId, currentDateTime) {
    let currentDateTimeStr = currentDateTime != null ? currentDateTime :
        formatDate(currentDateTime, 'yyyy-MM-dd HH:mm:ss');
    // departmentId = 73;
    // currentDateTimeStr = "2020-10-31 17:15:00";
    let data = {first: null, second: null};
    if (departmentId != null) {
        let response = await DutyServer.logbook.getWorkScheduleLogbook(departmentId, currentDateTimeStr);
        let result = response.data.result;
        let parsedResult = await parseSchedules([result.first, result.second]);
        data.first = parsedResult[0];
        data.second = parsedResult[1];
    }
    return Promise.resolve(data);
}

export const DUTY_KEY_FIRST = 'first';
export const DUTY_KEY_SECOND = 'second';

export function determineDutyKey(duties, defaultDutyKey) {
    let dutyKey = defaultDutyKey;
    let first = duties.first;
    if (first == null || first.logbook == null || first.logbook.status === 'DRAFT') {
        dutyKey = DUTY_KEY_FIRST;
    } else {
        dutyKey = DUTY_KEY_SECOND;
    }
    return dutyKey;
}
